import React from 'react';
import MapInterface from "./MapInterface";

export default function Map() {
    return <>
<MapInterface/>
</>
}